// extracted by mini-css-extract-plugin
export default {"aboutHeadline":"About_aboutHeadline__WjX0K","aboutParagraph":"About_aboutParagraph__hAp70"};